module.exports = __webpack_public_path__ + "static/media/user-master.9fc93b8d.svg";